import { render } from "./ApprovalNodeConfig.vue?vue&type=template&id=67425870&scoped=true&ts=true"
import script from "./ApprovalNodeConfig.vue?vue&type=script&lang=ts"
export * from "./ApprovalNodeConfig.vue?vue&type=script&lang=ts"

import "./ApprovalNodeConfig.vue?vue&type=style&index=0&id=67425870&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67425870"]])

export default __exports__